module.exports = __webpack_public_path__ + "static/media/MICAF-logo.aa85a436.png";